import classNames from 'classnames';
import { useCallback } from 'react';
import TapFeature from '@alltrails/amplitude/enums/TapFeature';
import logTrailCardClicked from '@alltrails/amplitude/events/logTrailCardClicked';
import { getUrlFromSlug } from '@alltrails/cards/utils/cardLinks';
import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Link from '@alltrails/denali/components/Link';
import styles from './TopResults.module.scss';

type Props = {
  trailId: number;
  trailSlug: string;
  trailName: string;
  className: string;
  description?: string;
};

const TrailCardShowMoreText = ({ trailId, trailSlug, trailName, className, description }: Props) => {
  const languageRegionCode = useLanguageRegionCode();
  const publicBaseUrl = usePublicBaseUrl();
  const href = getUrlFromSlug(`/${trailSlug}`, publicBaseUrl, languageRegionCode);

  const handleTrailClick = useCallback(
    (tapFeature: TapFeature) => {
      logTrailCardClicked({
        trail_id: String(trailId),
        card_location: 'seo',
        detailed_card_location: 'highlights carousel',
        tap_feature: tapFeature
      });
    },
    [trailId]
  );

  return (
    <Link href={href} target="_blank" className={styles.resultStatsLink} onClick={() => handleTrailClick('more link')} title={trailName}>
      <div className={classNames(styles.trailCardDescription, className)}>{description}</div>
    </Link>
  );
};

export default TrailCardShowMoreText;
